import React from "react";

export default function DynamicTestimonial({ data, extraClass = "" }) {
    if (!data) return null;
    return (
        <section className={`heathcare-business ${extraClass}`}>
            <div className="container">
                <div className="row align-items-end">
                    <div className="col-md-12 col-lg-6">
                        <div className="business-heading">
                            <h3 className="heading" dangerouslySetInnerHTML={{ __html: data?.section8_heading }} />
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <div className="business-content"> <p>{data?.section8_description}</p></div>
                    </div>
                </div>
                <div className="testimonial-box">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="star">
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                            </div>
                            <p className="testimonial-text">{data?.section8_testimonial1}  </p>
                            <div className="client-name">  {data?.section8_testimonial1_author} </div>
                        </div>
                        <div className="col-md-4">
                            <div className="star">
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                            </div>
                            <p className="testimonial-text">{data?.section8_testimonial2}  </p>
                            <div className="client-name">  {data?.section8_testimonial2_author} </div>
                        </div>
                        <div className="col-md-4">
                            <div className="star">
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                                <img src="/assets/images/star-icon1.webp" alt="Star" className="img-responsive" />
                            </div>
                            <p className="testimonial-text">{data?.section8_testimonial3}  </p>
                            <div className="client-name">  {data?.section8_testimonial3_author} </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}



